(function Module() {
	'use strict';

	module.exports = {
		i18n: require('./i18n'),
		util: require('./util'),
		validation: require('./validation'),
		factory: require('./factory')
	};
})();
